import styled from 'styled-components';

const TextArea = styled.textarea`
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--input);
  border-radius: 6px;
  color: var(--input-text);
  font-size: var(--regular);
  font-weight: var(--normal);
  outline: none;
  padding: 10px 14px;
  width: 100%;
  &::placeholder {
    color: var(--input);
  }
  &:focus {
    border-color: var(--input-focus);
  }
`;

export default TextArea;
